/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Mdx, Link } from '@ta-interaktiv/contentbricks'
import { Image } from 'components/image'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { ScrollTracking } from 'components/scrollTracking'
// TODO Set the correct article ID here
const ARTICLE_ID = '25480679'
const isMobile = browserCheck.isMobile
const isDisco = parseHostname().publicationName === 'bernerzeitung'
console.log(isDisco)
const steps = [
  {
    id: 1,
    text: (
      <>
Une bonne hygiène des mains doit être apprise dès l'enfance. Ce n'est que de cette façon que cela devient un automatisme. La première étape consiste à se mouiller les mains sous l'eau courante. Cela permet d'éliminer les saletés grossières.
      </>
    )
  },
  {
    id: 2,
    text: (
      <>
Savonnez-vous les mains, si possible avec du savon liquide et non avec des pains de savon – c'est plus hygiénique. Il n'est pas nécessaire de mettre des agents antibactériens dans le savon. Mais si vous vous lavez les mains sans savon, autant ne pas le faire. C'est du moins le conseil de 
{' '}
        <Link
          href='http://www.merkur.de/bayern/uni-test-haendewaschen-ohne-seife-bringt-nichts-971254.html'
          allowWordWrap
        >
          cette étude
        </Link>
        .
      </>
    )
  },
  {
    id: 3,
    text: (
      <>
Frottez vos mains jusqu'à ce qu'elles moussent. N'oubliez pas de frotter le dos de la main, entre les doigts, sous les ongles et sur les poignets. Il y a davantage de bactéries à éliminer sur le bout des doigts, sous les ongles, entre les doigts et aussi sur le pouce.
      </>
    )
  },
  {
    id: 4,
    text: (
      <>
Un lavage des mains efficace nécessite au moins 20 secondes, mieux encore 30 secondes. Mais en moyenne, les gens n'y consacrent que six secondes. Un savonnage d'une demi-minute tue 99,9% des agents pathogènes présents sur les mains.
      </>
    )
  },
  {
    id: 5,
    text: (
      <>
Rincez-vous soigneusement les mains sous l'eau courante. La température de l'eau n'a pas d'importance, elle n'affecte pas le nombre de bactéries. Il est également important que les mains soient bien soignées. Une peau abîmée peut être un véritable nid à microbes. En outre, les ongles doivent être coupés court.
      </>
    )
  },
  {
    id: 6,
    text: (
      <>
Séchez les mains avec une serviette propre, si possible avec un essuie-tout jetable, afin de réduire à nouveau les germes restant sur le bout des doigts en les frottant. En revanche, le séchage à l'aide d'appareils à air chaud et de serviettes textiles peut entraîner une augmentation de la charge bactérienne. Attention: les mains humides transmettent jusqu'à 1000 fois plus de germes que les mains sèches. Si vous vous lavez les mains dans les toilettes publiques, il est préférable de fermer le robinet avec une serviette en papier et d'ouvrir la porte avec votre coude.
      </>
    )
  }
]
export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch mediaName={isDisco ? 'disco' : undefined} />
      <ScrollTracking />
      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical  relaxed segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
            La seule chose qui protège contre les virus – et que tout le monde fait faux
              <div className='sub header'>
              Seul le lavage des mains offre une protection fiable contre les maladies virales et bactériennes. Voici pourquoi neuf personnes sur dix le font faux.
              </div>
            </div>
          </h1>
        </div>
      </header>

      <div className='ui vertical very fitted  segment'>
        <div className='ui text container '>
          <div className='ta author'>
            <nobr>Marc Brupbacher</nobr> et <nobr>Sebastian Broschinski</nobr>
          </div>
          <Mdx file={require('text/intro.mdx')} />

          <Image
            className='cbImage noBottomSpacing'
            file={require('images/notwashed-01.jpg')}
            title={<>On oublie souvent certaines parties des mains lors du lavage</>}
            sub={
              <>
Cette visualisation, bien qu'elle date un peu, est de nouveau d'actualité. Elle montre comment le personnel de santé américain se lave les mains et quelles zones sont souvent oubliées. Beaucoup de gens ne se lavent que la paume des mains, alors qu’il faut frotter toutes les parties de la main avec soin.
              </>
            }
            source={
              <>
                Source: Taylor, LJ.{' '}
                <Link
                  href='https://www.wakemed.org/documents/ForEmployees/Hand-Hygiene-Frequently-Missed-Areas.pdf'
                  allowWordWrap
                >
                  An evaluation of handwashingtechniques.
                </Link>{' '}
                NursingTimes. Janvier 1978.
              </>
            }
          >
            <div className='handAreasKey'>
              <div className='entry'>
                <div className='color red' />
                <div className='label'>les plus oubliées</div>
              </div>
              <div className='entry'>
                <div className='color orange' />
                <div className='label'>souvent oubliées</div>
              </div>
              <div className='entry'>
                <div className='color yellow' />
                <div className='label'>parfois oubliées</div>
              </div>
            </div>
          </Image>
        </div>
      </div>
      <div className='ui vertical very fitted segment'>
        <div className='ui text container '>
          <Mdx file={require('text/problem.mdx')} />
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container '>
          <h3>Se laver les mains correctement en six étapes.</h3>
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui  container '>
          <div className='stepContainer'>
            <div className='ui centered grid'>
              {steps.map((step, i) => {
                return (
                  <div
                    className={(isMobile ? 'sixteen' : 'five') + ' wide column'}
                    key={i}
                  >
                    <div className='number'>{step.id + '.'}</div>
                    <img
                      src={require('images/wasch_illu-0' + step.id + '.jpg')}
                      width='100%'
                    />
                    <div className='text'>{step.text}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>

      {/* <div className='ui vertical segment'>
        <div className='ui text container '>
          <Mdx file={require('text/tips.mdx')} />
        </div>
      </div> */}
      <div className='ui vertical segment'>
        <div className='ui text container '>
          <Mdx file={require('text/when.mdx')} />
        </div>
      </div>
      {/* <div className='ui vertical segment'>
        <div className='ui text container '>
          <Mdx file={require('text/pandemie.mdx')} />
        </div>
      </div> */}

      <Footer
        mailTo='atm@tamedia.ch'
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        questions={[
          'Ce contenu était-il informatif?',
          'La mise en forme vous plaît-elle?',
          'Vous êtes-vous bien lavé les mains la dernière fois?'
        ]}
        credits={[
          ['Conception et mise en oeuvre', 'Marc Brupbacher, Sebastian Broschinski'],
          [
            'Source',
            'Office fédéral de la santé publique (OFSP), Robert-Koch-Institut, Organisation mondiale de la santé OMS, www.sciencemediacenter.de'
          ]
        ]}
      />
    </div>
  )
}
